import React, { useMemo } from "react";
import {
  Autocomplete,
  Checkbox,
  ListItemText,
  MenuItem,
  Popper,
  TextField,
} from "@mui/material";
//import "../../Component/Common/ReuseableComponent/ReuseableComponent.css";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const AutocompleteCheckboxFixSizeUidA1 = ({
  options = [],
  xValue = [],
  xtabIndex = "",
  xDisabled = false,
  setValue,
  objName,
  label,
  placeholder,
}) => {
  const allOptions = useMemo(
    () => [{ UId: "select-all", NAME1: "Select All" }, ...options],
    [options]
  );

  const isAllSelected =
    xValue?.length > 0 &&
    options?.length > 0 &&
    xValue?.length === options?.length;

  const handleChange = (event, newValue, reason, details) => {
    if (!Array.isArray(newValue)) return;

    // Clear button case
    if (reason === "clear") {
      setValue((prev) => ({ ...prev, [objName]: [] }));
      return;
    }

    const clickedOption = details?.option;

    // If the user clicked on "Select All"
    if (clickedOption?.UId === "select-all") {
      if (isAllSelected) {
        // All are already selected -> unselect all
        setValue((prev) => ({ ...prev, [objName]: [] }));
      } else {
        // Select all options
        const allUids = options?.map((item) => item.UId);
        setValue((prev) => ({ ...prev, [objName]: allUids }));
      }
      return;
    }

    // Normal option selection (ignore "select-all" if it appears in newValue)
    const filtered = newValue.filter((item) => item.UId !== "select-all");
    const selectedUids = filtered.map((item) => item.UId);

    setValue((prev) => ({ ...prev, [objName]: selectedUids }));
  };

  const isSelected = (option) => xValue.includes(option.UId);

  return (
    <div
      className="GCAutocompleteCheckboxFixSize"
      style={{ background: xDisabled ? "#e9ecef" : "transparent" }}
    >
      <Autocomplete
        tabIndex={xDisabled ? "" : xtabIndex}
        disabled={xDisabled}
        multiple
        size="small"
        options={allOptions}
        
        getOptionLabel={(option) => option?.NAME1 || ""}
        value={options?.filter((grp) => xValue?.includes(grp.UId)) || []}
        isOptionEqualToValue={(option, value) => option.UId === value.UId}
        onChange={handleChange}
        disableCloseOnSelect
        PopperComponent={(props) => (
          <Popper
            {...props}
            style={{
              zIndex: 1300,
              width: props.anchorEl ? props.anchorEl.clientWidth : "auto",
            }}
            placement="bottom-start"
          />
        )}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            placeholder={placeholder}
            size="small"
            InputLabelProps={{
              shrink: true,
            }}
                       sx={{
              fontSize: "12px",
              "& .MuiOutlinedInput-root": {
                maxHeight: "31px",
                overflowY: "auto",
                border: "1px solid #ddd",
                padding: "0px !important",
                minWidth: "0px !important",
              },
              "& .MuiAutocomplete-input": {
                padding: "7.5px 4px 7.5px 5px !important",
              },
            }}
            // sx={{
            //   fontSize: "12px",
            //   "& .MuiOutlinedInput-root": {
            //     minHeight: "42px !important",
            //     height: "42px !important",
            //     border: "1px solid #ddd",
            //     padding: "0px !important",
            //     minWidth: "0px !important",
            //     overflowY: "auto",
            //     alignItems: "flex-start",
            //   },

            //   "& .MuiAutocomplete-inputRoot": {
            //     maxHeight: "40px",
            //     overflowY: "auto",
            //   },

            //   "& .MuiAutocomplete-input": {
            //     padding: "10px 6px 10px 8px !important",
            //   },

            //   "& .MuiInputBase-input": {
            //     height: "auto",
            //   },
            // }}
          />
        )}
        renderOption={(props, option, { selected }) => {
          if (option.UId === "select-all") {
            return (
              <MenuItem
                {...props}
                sx={{
                  height: "31px",
                  minHeight: "31px",
                  padding: "0 8px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Checkbox
                  size="small"
                  checked={isAllSelected}
                  indeterminate={
                    xValue?.length > 0 && xValue.length < options?.length
                  }
                />
                <ListItemText
                  primary="Select All"
                  primaryTypographyProps={{
                    fontSize: "12px",
                    lineHeight: "1.2",
                  }}
                />
              </MenuItem>
            );
          }

          return (
            <MenuItem
              {...props}
              sx={{
                height: "31px",
                minHeight: "31px",
                padding: "0 8px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <Checkbox size="small" checked={isSelected(option)} />
              <ListItemText
                primary={option?.NAME1}
                primaryTypographyProps={{
                  fontSize: "12px",
                  lineHeight: "1.2",
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                }}
              />
            </MenuItem>
          );
        }}
      />
    </div>
  );
};

export default AutocompleteCheckboxFixSizeUidA1;
